export const downloadBlob = (blob: Blob, filename: string) => {
    let blobUrl: string | null = null;
    let link: HTMLAnchorElement | null = null;

    try {
        blobUrl = window.URL.createObjectURL(blob);

        link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;

        document.body.appendChild(link);

        link.click();
    } catch (error) {
        console.error('Download failed:', error);
        throw error;
    } finally {
        if (link && document.body.contains(link)) {
            document.body.removeChild(link);
        }

        if (blobUrl) {
            window.URL.revokeObjectURL(blobUrl);
        }
    }
};
